<ng-template #tooltipTemplate let-tooltip="tooltip">
  <div class="tooltip" [class.tooltip-block]="tooltip?.length > 1">
    @for (t of tooltip; track $index) {
      @if (t.category) {
        <div class="tooltip-item">
          @if (t.matsymbol) {
            <i
              class="material-symbols-rounded"
              [ngStyle]="{
                'padding-right': '6px',
                'font-variation-settings': t.matsymbol.fill && '\'FILL\' 1',
                'font-size': t.matsymbol.size
                  ? t.matsymbol.size + 'px'
                  : '10px',
                color: t.color,
              }"
              >{{ t.matsymbol.symbol }}</i
            >
          }
          <span
            ><b>{{ t.category }}:</b> {{ t.value | formatNumber: 0 : 2 }}%</span
          >
        </div>
      }
    }
  </div>
</ng-template>

<div
  class="donut-chart-container"
  [id]="chart().id + '-donut-chart'"
  poziOverlay
  [template]="chartData()[0]?.category ? tooltipTemplate : undefined"
  [templateContext]="{ tooltip: chartData() }"
  [cdkOverlayPositionPairs]="cdkOverlayPositionPairs"
>
  <svg width="100%" height="100%" [attr.viewBox]="viewBox" class="donut">
    <!-- base ring -->
    <circle
      [attr.cx]="center"
      [attr.cy]="center"
      [attr.r]="radius"
      fill="transparent"
      [attr.stroke]="ringStrokeColor"
      [attr.stroke-width]="strokeWidth"
    ></circle>

    <!-- all segments, appended in reverse order -->
    @for (segment of segments; track $index) {
      <circle
        [attr.cx]="center"
        [attr.cy]="center"
        [attr.r]="radius"
        fill="transparent"
        [attr.stroke]="borderStrokeColor"
        [attr.stroke-width]="strokeWidth + borderStrokeWidth"
        [attr.stroke-dasharray]="segment.main.strokeDashArray"
        [attr.stroke-dashoffset]="segment.main.strokeDashOffset"
        stroke-linecap="round"
      ></circle>

      <circle
        [attr.cx]="center"
        [attr.cy]="center"
        [attr.r]="radius"
        fill="transparent"
        [attr.stroke]="segment.color"
        [attr.stroke-width]="strokeWidth"
        [attr.stroke-dasharray]="segment.main.strokeDashArray"
        [attr.stroke-dashoffset]="segment.main.strokeDashOffset"
        stroke-linecap="round"
      ></circle>
    }

    <!-- optional overlap segments, appended in reverse order -->
    <!-- segments order adjusted: largest slice drawn last to avoid overflow issues -->
    @for (segment of rotateByMaxValue(segments); track $index) {
      @if (segment?.overlap && segment?.overlapBorder) {
        <circle
          [attr.cx]="center"
          [attr.cy]="center"
          [attr.r]="radius"
          fill="transparent"
          [attr.stroke]="borderStrokeColor"
          [attr.stroke-width]="strokeWidth + borderStrokeWidth"
          [attr.stroke-dasharray]="segment.overlapBorder!.strokeDashArray"
          [attr.stroke-dashoffset]="segment.overlapBorder!.strokeDashOffset"
          stroke-linecap="round"
        ></circle>

        <circle
          [attr.cx]="center"
          [attr.cy]="center"
          [attr.r]="radius"
          fill="transparent"
          [attr.stroke]="segment.color"
          [attr.stroke-width]="strokeWidth"
          [attr.stroke-dasharray]="segment.overlap!.strokeDashArray"
          [attr.stroke-dashoffset]="segment.overlap!.strokeDashOffset"
          stroke-linecap="round"
        ></circle>
      }
    }
  </svg>
</div>
